export const getUniqueId = () => {
	return (
		'A' +
		Math.random()
			.toString(36)
			.substring(2, 15) +
		Date.now().toString()
	);
};
